<template>
    <div>
        <label
            class="title bold tw-mb-2 tw-block"
            v-if="!hideLabel">
            <span v-if="label">{{ label }}</span>
            <span v-else>{{ mode == "image" ? "Afbeelding" : "Video" }}</span>
        </label>
        <file-pond
            v-bind="settings"
            name="file"
            ref="pond"
            @updatefiles="updateFiles($event)"
        />
    </div>
</template>

<script>
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';

import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import nlFilePondAttrs from 'filepond/locale/nl-nl.js';

const FilePond = vueFilePond(FilePondPluginImagePreview);

export default {
    name: 'app',
    props: {
        value: {
            type: [String, Object, Array],
            default: ''
        },
        file: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        }
    },
    computed: {
        settings() {
            return {
                ...nlFilePondAttrs,
                'accepted-file-types': 'image/jpeg, image/png',
                credits: '',
                instantUpload: false,
                maxFiles: 1,
                files: this.file && [
                    {
                        source: this.file,
                        options: {
                            type: 'local'
                        }
                    }
                ],
                server: {
                    load: (source, load, error, progress, abort, headers) => {
                        var myRequest = new Request(source);
                        fetch(myRequest).then(function (response) {
                            response.blob().then(function (myBlob) {
                                load(myBlob);
                            });
                        });
                    }
                }
            };
        }
    },
    methods: {
        updateFiles(items) {
            this.$emit('input', items.length ? items : false);
        }
    },
    components: {
        FilePond
    }
};
</script>
